export default __webpack_public_path__ + "static/media/caret-right-fill.5bad882f.svg";